import { copy } from '../content/copy';
import { SectionLabel } from '../components/SectionLabel';

export function HowItWorks() {
  const { howItWorks } = copy;
  return (
    <section className="bg-l-paper px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px] grid grid-cols-1 md:grid-cols-[5fr_7fr] gap-10 md:gap-14 items-center">
        <div>
          <SectionLabel>РАЗДЕЛ 03 · КАК ПРОХОДИТ ЗАНЯТИЕ</SectionLabel>
          <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-6">
            {howItWorks.title}
          </h2>
          <p className="font-sans text-l-ink text-[17px] leading-[1.6] mb-5">
            {howItWorks.body}
          </p>
          <a href="/app" className="font-sans text-l-terracotta hover:text-l-marginalia transition-colors underline-offset-4 hover:underline">
            {howItWorks.linkText}
          </a>
        </div>
        <div className="rounded-xl overflow-hidden border border-l-rule/60 bg-l-paper-soft aspect-[16/10]">
          {/* TODO: заменить на реальный скрин board-preview.webp, когда будет готов */}
          <div className="w-full h-full flex items-center justify-center font-sans text-l-ink-muted italic text-sm">
            Скриншот интерактивной доски
          </div>
        </div>
      </div>
    </section>
  );
}
